import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AssetPreview from '../assetpreview/AssetPreview'
import MarketContent from '../common/layout/Content'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import Pagination from '../pagination/Pagination'
import { useSharedState } from '../waxplorer/Waxplorer'

export default function UnclaimedPacksList(props) {
    const [assets, setAssets] = useState([])
    const [offset, setOffset] = useState(0)
    const limit = 40
    const isLoading = props['isLoading']
    const unpacked = props['unpacked']
    const setIsLoading = props['setIsLoading']

    const user = props['user']
    const assetIds = props['assetIds']
    const [state, dispatch] = useSharedState()

    const getAssetsResult = (result, unboxer) => {
        const assets = []
        if (result) {
            result.map((asset) => {
                asset['owner'] = unboxer
                assets.push(asset)
            })
        }

        setAssets(assets)
        setIsLoading(false)
    }

    const getAssets = async (asset_ids) => {
        return await get(`claimable-packs?asset_ids=${asset_ids}`, 'legacy')
    }

    useEffect(() => {
        if (assetIds && assetIds.length > 0)
            getAssets(assetIds).then((res) => getAssetsResult(res, user))
        else {
            setAssets([])
            setIsLoading(false)
        }
    }, [assetIds, unpacked])

    const { t } = useTranslation('common')

    return (
        <MarketContent>
            <div className={cn('w-full grid grid-cols-8 gap-10')}>
                <div className={cn('col-span-8 sm:col-span-8')}>
                    {!isLoading && assets && (
                        <Pagination
                            result={assets.data}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            location={'Top'}
                        />
                    )}
                    {isLoading ? (
                        <LoadingIndicator />
                    ) : assets && assets.length > 0 ? (
                        <div className={'w-full h-auto mb-4 mt-4'}>
                            <div
                                className={cn(
                                    'grid sm:gap-4 gap-2 grid-cols-1 xsse:grid-cols-2 sm1:grid-cols-3 md:grid-cols-3 md1:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 4xl:grid-cols-7 text-center sm:mx-4 mx-2',
                                )}
                            >
                                {assets.map((asset, index) => (
                                    <AssetPreview
                                        {...props}
                                        key={index}
                                        index={index}
                                        asset={asset}
                                        page={'claims'}
                                        state={state}
                                        dispatch={dispatch}
                                        selectedAssets={state.selectedAssets}
                                        isSelected={
                                            state.selectedAssets &&
                                            state.selectedAssets
                                                .map(
                                                    (a) =>
                                                        (a.assets?.length > 0
                                                            ? a.assets[0]
                                                            : a
                                                        ).assetId,
                                                )
                                                .includes(
                                                    (asset.assets?.length > 0
                                                        ? asset.assets[0]
                                                        : asset
                                                    ).assetId,
                                                )
                                                ? (asset.assets?.length > 0
                                                      ? asset.assets[0]
                                                      : asset
                                                  ).assetId
                                                : null
                                        }
                                        handleCheck={(e, asset) =>
                                            handleCheck(e, asset, state)
                                        }
                                        errorAssets={state.errorAssets}
                                        transferredAssets={
                                            state.transferredAssets
                                        }
                                    />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div
                            className={
                                'flex justify-center w-full text-lg font-semibold'
                            }
                        >
                            {t('unpack.no_unclaimed_packs_found')}
                        </div>
                    )}
                    {isLoading ? (
                        ''
                    ) : (
                        <Pagination
                            result={assets.data}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            location={'Bottom'}
                        />
                    )}
                </div>
            </div>
        </MarketContent>
    )
}
